import React, { useState, useCallback, useRef, useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

import { DropDownItem } from 'components/dropdown-nav';
import { MoreNavItemComponent, NavItem, NavItemH } from './nav-item';
import { separateNavItemsInMore } from './utils';

export function DesktopMenuContent({ navigationChannels, navigationRootChannels, availableWidth }) {
  const ro = useRef();
  const initialWidth = useRef();
  const [, triggerMenuRecalculation] = useState(0);
  const [enabledNavItemId, setEnabledNavItemId] = useState(undefined);

  useEffect(
    () => () => {
      if (ro.current) {
        ro.current.disconnect();
      }
    },
    []
  );

  const measuredRef = useCallback((node) => {
    if (node) {
      ro.current = new ResizeObserver((entries) => {
        window.requestAnimationFrame(() => {
          const nextWidht = entries[0].contentRect.width;

          if (
            initialWidth.current &&
            Math.abs(initialWidth.current - nextWidht) > nextWidht / 20 // avoid rerenderin in case of 5% width changes
          ) {
            triggerMenuRecalculation(nextWidht);
          }
          initialWidth.current = nextWidht;
        });
      });

      ro.current.observe(node);
    }
  }, []);

  if (!availableWidth) {
    return null;
  }

  let items = separateNavItemsInMore(navigationChannels, navigationRootChannels, availableWidth);
  sessionStorage.setItem('isSiteLoaded', true);

  const showDropDownMenuHandler = (id) => setEnabledNavItemId(id);
  const hideDropDownMenuHandler = () => setEnabledNavItemId(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();

      hideDropDownMenuHandler();
    }
  };

  return (
    <div
      role="list"
      id="ct-navigation"
      className="ct-navigation-content"
      data-e2e={'ct-navigation'}
      ref={measuredRef}
      onKeyDown={handleKeyDown}
    >
      {items.inNav.map((navItem) => {
        return (
          <NavItem
            key={`channel_${navItem.id}`}
            navItem={navItem}
            ariaRole="listitem"
            isMenuShown={navItem.id === enabledNavItemId}
            onClosing={hideDropDownMenuHandler}
            onOpen={() => showDropDownMenuHandler(navItem.id)}
          />
        );
      })}
      {items.inMore.length > 0 && (
        <MoreNavItemComponent activeClass={items.inMore.some((item) => item.active) ? 'active' : ''}>
          {items.inMore.map((navItem, index) => (
            <DropDownItem className={navItem.active ? 'active level' : 'level'} key={'more-link-' + index}>
              <NavItemH navItem={navItem} />
            </DropDownItem>
          ))}
        </MoreNavItemComponent>
      )}
    </div>
  );
}
